import React, { useState, useEffect } from "react";

export const TablaDatos = ({ data, columns, handleActionClick }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setitemsPerPage] = useState(10);

  // Filtrar la lista de datos en función del término de búsqueda
  const filteredData = data.filter((item) => {
    const values = Object.values(item).join(" ").toLowerCase();
    return values.includes(searchTerm.toLowerCase());
  });
 
  // Calcular el índice del último elemento de la página actual
  const lastIndex = currentPage * itemsPerPage;
  // Calcular el índice del primer elemento de la página actual
  const firstIndex = lastIndex - itemsPerPage;
  // Obtener los elementos de la página actual
  const currentItems = filteredData.slice(firstIndex, lastIndex);

  // Calcular el número total de páginas
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Cambiar la página actual
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    setCurrentPage(1); // Resetear la página actual cuando cambie el término de búsqueda
  }, [searchTerm, data]);

  return (
    <div className="card card-flush">
      <div className="card-header align-items-center py-5 gap-2 gap-md-5">
        <div className="card-title">
          <div className="d-flex align-items-center position-relative my-1">
            <i className="ki-duotone ki-magnifier fs-3 position-absolute ms-4">
              <span className="path1" />
              <span className="path2" />
            </i>{" "}
            <input
              type="text"
              data-kt-ecommerce-order-filter="search"
              className="form-control   w-250px ps-12"
              placeholder="Buscar"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm !== "" && (
              <div className="icon-sm position-absolute end-0 me-3 top-50 translate-middle-y">
                <i
                  className="fas fa-times fs-3"
                  onClick={() => setSearchTerm("")}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="card-body pt-0">
        <div
          id="kt_ecommerce_report_shipping_table_wrapper"
          className="dataTables_wrapper dt-bootstrap4 no-footer"
        >
          <div className="table-responsive">
            <table
              className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer"
              id="kt_ecommerce_report_shipping_table"
            >
              <thead>
                <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                  {columns.map((column, index) => (
                    <th key={index}>{column.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="fw-semibold text-gray-600">
                {currentItems.length == 0 && data.length > 0 ? (
                  <tr>
                    <td colSpan={columns.length} className="text-center">
                      No se encontraron resultados para la búsqueda '
                      <strong>{searchTerm}</strong>'.
                    </td>
                  </tr>
                ) : (
                  currentItems.map((item, index) => (
                    <tr key={index}>
                      {columns.map((column, colIndex) => (
                        <td key={colIndex}>
                          {column.field === "actions" ? (
                            // Agregar un botón u otro componente aquí según el campo "actions"
                            <button
                              onClick={
                                column.handleActionClick != null
                                  ? () => column.handleActionClick(item)
                                  : column.modalId != null
                                  ? null
                                  : () => handleActionClick(item)
                              }
                              className="btn btn-primary btn-sm"
                              data-bs-toggle={column.modalId ? "modal" : ""}
                              data-bs-target={column.modalId ?? ""}
                            >
                              {column.title}
                            </button>
                          ) : column.envoltorio != null ? (
                            <column.envoltorio>
                              {column.field != null ? item[column.field] : ""}
                            </column.envoltorio>
                          ) : (
                            item[column.field]
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className="row">
            <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start">
              <div
                className="dataTables_length"
                id="kt_ecommerce_report_shipping_table_length"
              >
                <label>
                  <select
                    name="kt_ecommerce_report_shipping_table_length"
                    aria-controls="kt_ecommerce_report_shipping_table"
                    className="form-select form-select-sm  "
                    value={itemsPerPage}
                    onChange={(e) => {
                      setitemsPerPage(e.target.value);
                    }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>
                </label>
              </div>
            </div>
            <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="kt_ecommerce_report_shipping_table_paginate"
              >
                <ul className="pagination">
                  <li
                    className={`paginate_button page-item previous ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                    id="kt_ecommerce_report_shipping_table_previous"
                  >
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      className="page-link"
                    >
                      <i className="previous" />
                    </button>
                  </li>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <li
                      key={index}
                      className={`paginate_button page-item ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                    >
                      <button
                        onClick={() => handlePageChange(index + 1)}
                        className="page-link"
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}
                  <li
                    className={`paginate_button page-item next ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                    id="kt_ecommerce_report_shipping_table_next"
                  >
                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      className="page-link"
                    >
                      <i className="next" />
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaDatos;
